<div class="container">
  <div class="header">
    <h2>Documentos do Concurso</h2>
    <p class="mat-body-1" *ngIf="anonimo">Visualização anônima dos documentos complementares das inscrições habilitadas.</p>
    <p class="mat-body-1" *ngIf="!anonimo">Documentos complementares das inscrições habilitadas.</p>
  </div>

  <div *ngIf="carregando" class="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Carregando documentos...</span>
  </div>

  <div *ngIf="!carregando && candidatos.length === 0" class="empty">
    <mat-icon>folder_off</mat-icon>
    <p>Nenhum documento encontrado.</p>
  </div>

  <mat-accordion *ngIf="!carregando && candidatos.length > 0" multi>

    <!-- Collapse 1: Memorial e Comprovantes -->
    <mat-expansion-panel *ngIf="candidatosMemorial.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="grupo-icon">description</mat-icon>
          Memorial e Comprovantes
        </mat-panel-title>
        <mat-panel-description>
          {{ candidatosMemorial.length }} candidato(s)
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="lista-documentos">
        <mat-card *ngFor="let docs of candidatosMemorial; let i = index" class="documento-card">
          <div class="documento-content">
            <div class="documento-info">
              <span class="documento-nome">{{ getCandidatoLabel(i, docs) }}</span>
            </div>
            <div class="documento-acoes">
              <button
                mat-icon-button
                color="primary"
                (click)="visualizarDocumento(getMemorial(docs)!, i, 0)"
                [disabled]="!getMemorial(docs) || isDownloading(getMemorial(docs)!)"
                matTooltip="Memorial">
                <mat-icon *ngIf="!getMemorial(docs) || !isDownloading(getMemorial(docs)!)">history_edu</mat-icon>
                <mat-spinner *ngIf="getMemorial(docs) && isDownloading(getMemorial(docs)!)" diameter="20"></mat-spinner>
              </button>
              <button
                mat-icon-button
                color="primary"
                (click)="visualizarDocumento(getComprovantes(docs)!, i, 1)"
                [disabled]="!getComprovantes(docs) || isDownloading(getComprovantes(docs)!)"
                matTooltip="Comprovantes">
                <mat-icon *ngIf="!getComprovantes(docs) || !isDownloading(getComprovantes(docs)!)">fact_check</mat-icon>
                <mat-spinner *ngIf="getComprovantes(docs) && isDownloading(getComprovantes(docs)!)" diameter="20"></mat-spinner>
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-expansion-panel>

    <!-- Collapse 2: Plano de Trabalho -->
    <mat-expansion-panel *ngIf="candidatosPlano.length > 0" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="grupo-icon">work</mat-icon>
          Plano de Trabalho
        </mat-panel-title>
        <mat-panel-description>
          {{ candidatosPlano.length }} candidato(s)
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="lista-documentos">
        <mat-card *ngFor="let docs of candidatosPlano; let i = index" class="documento-card">
          <div class="documento-content">
            <div class="documento-info">
              <span class="documento-nome">{{ getCandidatoLabel(i, docs) }}</span>
              <span class="documento-tamanho" *ngIf="docs[0]?.tamanhoArquivo">{{ formatarTamanho(docs[0].tamanhoArquivo) }}</span>
            </div>
            <button
              mat-icon-button
              color="primary"
              (click)="visualizarDocumento(docs[0], i, 0)"
              [disabled]="isDownloading(docs[0])"
              matTooltip="Visualizar documento">
              <mat-icon *ngIf="!isDownloading(docs[0])">visibility</mat-icon>
              <mat-spinner *ngIf="isDownloading(docs[0])" diameter="20"></mat-spinner>
            </button>
          </div>
        </mat-card>
      </div>
    </mat-expansion-panel>

  </mat-accordion>

  <div class="actions">
    <button mat-flat-button color="primary" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon>
      Voltar
    </button>
  </div>
</div>
